import React from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TRANSLATIONS } from '../../constants/translations';
import { translate } from '../../helpers/translationHelper';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Result
        status="404"
        title="404"
        subTitle={translate(t, TRANSLATIONS.NOT_FOUND)}
        extra={
          <Button type="primary">
            <Link to="/">{translate(t, TRANSLATIONS.GOHOME)}</Link>
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
